"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_query_1 = require("./base-query");
class BaseQueryNode {
    static deserialize(obj) {
        let node = new BaseQueryNode();
        node.baseQuery = base_query_1.default.deserialize(obj.baseQuery);
        node.joins = (obj.joins || []).map(join => ({
            node: BaseQueryNode.deserialize(join.node),
            joinType: join.joinType,
            joinNodeId: join.joinNodeId,
        }));
        return node;
    }
    serialize() {
        return {
            baseQuery: this.baseQuery.serialize(),
            joins: this.joins.map(j => ({
                node: j.node.serialize(),
                joinType: j.joinType,
                joinNodeId: j.joinNodeId,
            })),
        };
    }
    // eslint-disable-next-line no-unused-vars
    forEach(f) {
        this.baseQuery.forEach(f);
        this.joins.forEach(join => join.node.forEach(f));
    }
    validate(datasetRepo) {
        let bqValid = this.baseQuery.validate(datasetRepo);
        // Check that all the joins primary dataset share grain with this node
        let thisDsDef = datasetRepo.datasetByName[this.baseQuery.tableNodes[0].dataset];
        return bqValid && this.joins.every(join => {
            // this.baseQuery.canJoinDirectly(join.node.baseQuery)
            let thatDsDef = datasetRepo.datasetByName[join.node.baseQuery.tableNodes[0].dataset];
            for (let grain of thatDsDef.tableGrain) {
                if ((!!join.joinNodeId && this.lookup(join.joinNodeId)) || thisDsDef.tableGrain.includes(grain))
                    return true;
            }
            return false;
        });
    }
    lookup(id) {
        let node = this.baseQuery.lookup(id);
        if (node)
            return node;
        for (let join of this.joins) {
            node = join.node.lookup(id);
            if (node)
                return node;
        }
        return null;
    }
}
exports.default = BaseQueryNode;
